import * as React from "react";
import { PaletteColor, useThemePaletteColor } from "./types";

const wirePath =
    "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0" +
    " 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z";

const filledPath =
    "m528,0l-480,0c-26.5,0 -48,21.5 -48,48l0,320c0,26.5 21.5,48 48,48l192,0l-16,48l-72,0c-13.3,0 -24,10.7 -24,24s10.7,24" +
    " 24,24l272,0c13.3,0 24,-10.7 24,-24s-10.7,-24 -24,-24l-72,0l-16,-48l192,0c26.5,0 48,-21.5 48,-48l0,-320c0,-26.5 -21.5,-48 -48," +
    "-48zm-219,226l-15,-12l-7,-4l10,7l12,9z";

type Props = {
    style?: React.CSSProperties;
    color?: PaletteColor;
    filled?: boolean;
};

export default ({ style, color = "default", filled }: Props) => {
    const colorVal = useThemePaletteColor(color);

    return (
        <svg version="1.0" width="64px" height="64px" viewBox="0 0 576 512" style={style}>
            <path id="svg_1" d={filled ? filledPath : wirePath} fill={colorVal} />
        </svg>
    );
};
